import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '@/hoc';
import React, { useEffect, useMemo, useRef } from 'react';
import { createPortal } from 'react-dom';
import Button from './common/Button';
import IconClose from './icons/IconClose';
var Popup = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, title = _a.title, subTitle = _a.subTitle, children = _a.children, footer = _a.footer, _b = _a.className, className = _b === void 0 ? '' : _b;
    var theme = useTheme().theme;
    var containerRef = useRef(null);
    var popupRoot = useMemo(function () {
        var popupRoot = document.getElementById('popup-root') || document.createElement('div');
        if (!popupRoot.parentElement) {
            popupRoot.id = 'popup-root';
            document.documentElement.appendChild(popupRoot);
        }
        containerRef.current = popupRoot;
        return popupRoot;
    }, []);
    useEffect(function () {
        var container = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
        if (!container)
            return;
        var setThemeProperties = function (obj, prefix) {
            if (prefix === void 0) { prefix = ''; }
            Object.entries(obj).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (typeof value === 'object' && value !== null) {
                    setThemeProperties(value, "".concat(prefix).concat(key, "-"));
                }
                else {
                    container.style.setProperty("--".concat(prefix).concat(key), String(value));
                }
            });
        };
        setThemeProperties(theme);
    }, [theme, containerRef === null || containerRef === void 0 ? void 0 : containerRef.current]);
    useEffect(function () {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
        return function () {
            document.body.style.overflow = '';
        };
    }, [isOpen]);
    if (!isOpen)
        return null;
    return createPortal(_jsx("div", { className: "vas-fixed vas-inset-0 vas-z-100050 vas-flex vas-items-center vas-justify-center vas-bg-black vas-bg-opacity-50", "aria-modal": 'true', role: 'dialog', children: _jsxs("div", { className: "vas-bg-white vas-rounded-lg vas-shadow-xl vas-w-full vas-max-w-md vas-p-6 ".concat(className), children: [_jsxs("div", { className: 'vas-flex vas-justify-between vas-items-start vas-mb-4', children: [_jsxs("div", { children: [title && (_jsx("h2", { className: 'vas-text-vastypographyHeadingFontSize vas-font-vastypographyHeadingFontWeight vas-text-vastypographyHeadingTextColor', children: title })), subTitle && (_jsx("p", { className: 'vas-text-vastypographySubheadingFontSize vas-font-vastypographySubheadingFontWeight vas-text-vastypographySubHeadingTextColor', children: subTitle }))] }), _jsx(Button, { onClick: onClose, className: 'vas-p-2 vas-rounded-full vas-bg-vasSecondary vas-text-primary hover:vas-bg-vasSecondary/20 focus:vas-outline-none focus:vas-ring-2 focus:vas-ring-primary', "aria-label": 'Close modal', children: _jsx(IconClose, { className: 'vas-size-3' }) })] }), _jsx("div", { className: 'vas-mb-4', children: children }), footer && _jsx("div", { className: 'vas-flex vas-justify-end vas-space-x-2', children: footer })] }) }), popupRoot);
};
export default Popup;
